/* eslint-disable max-len */
export const ONLINE_STORE_ID = '8119';
export const TYPE_LIST = ['PIP', 'PLP', 'MINI'];

export const CHECKOUT_STRINGS = {
  heading: 'It\'s Not Just About Where It Goes, But How It Gets There.',
  body: 'Being unable to receive a delivery for any reason is frustrating, costly, and time-consuming. Before making your purchase, we recommend reviewing the Fit & Delivery checklist to ensure the smoothest delivery day possible.',
  buttonLabel: 'Fit & Delivery Checklist',
  checkboxLabel: 'I\'ve taken the appropriate measurements',
};

export const MEASURE_TWICE_STRINGS = {
  headingPrefix: 'MEASURE TWICE, ',
  headingAccent: 'BUY ONCE.',
  body: 'Returns are frustrating, expensive, and (mostly) avoidable.'
    + ' Review this checklist before committing to your purchase.',
  footnotePrefix: '*Damaged or defective major appliances are returnable'
    + ' within 48 hours through a scheduled pickup only. ',
  footnoteLinkText: 'See Return Policy.',
  returnPolicyUrl: 'https://www.homedepot.com/c/Return_Policy',
};

export const CHECKOUT_APPLIANCE_TYPE_ORDER = [
  'REFRIGERATOR',
  'LAUNDRY',
  'RANGE',
  'DISHWASHER',
  'OTR_MICROWAVES',
];

export const VALID_APPLIANCE_TYPES = [
  'REFRIGERATOR',
  'FRIDGE',
  'LAUNDRY',
  'WASHER',
  'DRYER',
  'ALL-IN-ONE',
  'RANGE',
  'OTR_MICROWAVES',
  'DISHWASHER',
];
export const TYPES_BY_CLASS = {
  DISHWASHER: {
    class: '7',
    subclasses: ['2', '3', '7', '8', '9', '999'],
  },
  LAUNDRY: {
    class: '8',
    subclasses: [
      '3', '4', '5', '6', '7', '8', '9',
      '11', '12', '13', '14', '15', '16', '17', '18',
      '19', '20', '21', '23', '24', '25', '26',
      '27', '29', '31', '32', '33', '34', '35',
      '36', '999',
    ],
  },
  REFRIGERATOR: {
    class: '13',
    subclasses: ['4', '5', '6', '7', '8', '14', '17', '18', '19', '20', '22', '23', '999'],
  },
  RANGE: {
    class: '15',
    subclasses: ['2', '3', '5', '6', '15', '18', '25', '26', '27', '999'],
  },
  OTR_MICROWAVES: {
    class: '15',
    // OTR microwave identification via subclass 10 on class 15
    subclasses: ['10'],
  },
};

export const WIDGET_MAPPING = {
  REFRIGERATOR: {
    PIP: {
      header: 'Will This Refrigerator Fit My Space?',
      subtext: 'Measure your space, not your old refrigerator.',
      subSubtext: 'The calculator adds required clearances for the appliance',
      canHaveArrow: true,
      hasInitialBackArrow: false,
      isPip: true
    },
    PLP: {
      header: 'Find Refrigerators That Fit Your Home',
      subtext: 'Measure your space to help you narrow down what works.',
      canHaveArrow: true,
      hasInitialBackArrow: false,
      isPlp: true
    },
    MINI: {
      header: 'Make sure it fits',
      hasInitialBackArrow: true,
      isMini: true
    },
    FIT: {
      header: 'Hooray! This Refrigerator Fits Your Space',
      subtext: 'this fridge sticks out {depthOverhang} inches from your countertop. This depth is still considered a well-fitted installation.',
      isPip: true
    },
    NO_FIT: {
      header: 'This Refrigerator Doesn\'t Fit Your Space',
      subtext: 'Check your measurements or view other options',
      isPip: true
    }
  },
  LAUNDRY: {
    PIP: {
      header: 'Make Sure It Fits Your Space',
      subtext: 'Learn how to measure for easy installation',
      canHaveArrow: false,
      hasInitialBackArrow: false,
      isPip: true
    },
    PLP: {
      header: 'Find a Washer & Dryer That Fit Your Home',
      subtext: 'Measure your space to help you narrow down what works.',
      canHaveArrow: true,
      hasInitialBackArrow: false,
      isPlp: true
    },
    MINI: {
      header: 'Make sure it fits',
      hasInitialBackArrow: true,
      isMini: true
    },
  },
  RANGE: {
    PIP: {
      header: 'Make Sure It Fits Your Space',
      subtext: 'Learn how to measure for easy installation',
      canHaveArrow: false,
      hasInitialBackArrow: false,
      isPip: true
    },
    PLP: {
      header: 'Find a Range That Fits Your Home',
      subtext: 'Measure your space to help you narrow down what works.',
      canHaveArrow: true,
      hasInitialBackArrow: false,
      isPlp: true
    },
    MINI: {
      header: 'Make sure it fits',
      hasInitialBackArrow: true,
      isMini: true
    },
  },
  OTR_MICROWAVES: {
    PIP: {
      header: 'Make Sure It Fits Your Space',
      subtext: 'Learn how to measure for easy installation',
      canHaveArrow: false,
      hasInitialBackArrow: false,
      isPip: true
    },
    PLP: {
      header: 'Find an Over-the-Range Microwave That Fits Your Home',
      subtext: 'Measure your space to help you narrow down what works.',
      canHaveArrow: true,
      hasInitialBackArrow: false,
      isPlp: true
    },
    MINI: {
      header: 'Make sure it fits',
      hasInitialBackArrow: true,
      isMini: true
    },
  },
  DISHWASHER: {
    PIP: {
      header: 'Make Sure It Fits Your Space',
      subtext: 'Learn how to measure for easy installation',
      canHaveArrow: false,
      hasInitialBackArrow: false,
      isPip: true
    },
    PLP: {
      header: 'Find a Dishwasher That Fits Your Home',
      subtext: 'Measure your space to help you narrow down what works.',
      canHaveArrow: true,
      hasInitialBackArrow: false,
      isPlp: true
    },
    MINI: {
      header: 'Make sure it fits',
      hasInitialBackArrow: true,
      isMini: true
    },
  }
};

export const DIMENSIONS = [
  { key: 'width', label: 'Width', placeholder: 'Ex: 36.5', drawerIndex: 2 },
  { key: 'height', label: 'Height', placeholder: 'Ex: 96', drawerIndex: 3 },
  { key: 'depth', label: 'Depth', placeholder: 'Ex: 24', drawerIndex: 4 },
];
export const RECOMMENDED_CLEARANCE = {
  width: 4.5,
  height: 1,
  depth: 2
};

export const APPLIANCE_FITS = {
  FITS: 'FITS',
  DOES_NOT_FIT: 'DOES_NOT_FIT',
  MOSTLY_FITS: 'MOSTLY_FITS',
  FITS_WITH_OVERFLOW: 'FITS_WITH_OVERFLOW'
};

export const SIXTY_DAYS_IN_MS = 5184000000;